import React, { useState } from 'react';
import { EyeIcon, EyeOffIcon, InfoIcon, LockIcon, UserIcon } from 'lucide-react';
import { ForgotPassword } from './ForgotPassword';
interface LoginCardProps {
  onLogin: () => void;
}
export function LoginCard({
  onLogin
}: LoginCardProps) {
  const [userId, setUserId] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [showForgotPassword, setShowForgotPassword] = useState(false);
  const [loginError, setLoginError] = useState('');
  // Check if form has valid format (for UI validation only)
  const isValidForm = userId.trim() !== '' && password.length >= 12;
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setLoginError(''); // Clear any previous errors
    // Check for specific credentials
    if (userId === 'admin' && password === 'aDmin@123456') {
      onLogin();
    } else {
      // Show error message for invalid credentials
      setLoginError('Invalid username or password');
    }
  };
  if (showForgotPassword) {
    return <ForgotPassword onBack={() => setShowForgotPassword(false)} data-id="element-45" />;
  }
  return <div className="bg-white rounded-lg shadow-lg p-8 border border-gray-200 transform transition-all" data-id="element-46">
      <div className="flex justify-center mb-6" data-id="element-47">
        <div className="w-16 h-16 bg-[#F58220] bg-opacity-10 rounded-full flex items-center justify-center" data-id="element-48">
          <LockIcon size={28} className="text-[#F58220]" data-id="element-49" />
        </div>
      </div>
      <h2 className="text-2xl font-semibold text-[#1A1F36] mb-2 text-center" data-id="element-50">
        Login to Your Account
      </h2>
      <p className="text-gray-500 text-center mb-6" data-id="element-51">
        Enter your credentials to access the portal
      </p>
      {loginError && <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-md mb-4" data-id="element-52">
          {loginError}
        </div>}
      <form onSubmit={handleSubmit} className="space-y-6" data-id="element-53">
        <div className="space-y-2" data-id="element-54">
          <label htmlFor="userId" className="block text-sm font-medium text-gray-700" data-id="element-55">
            User ID
          </label>
          <div className="relative" data-id="element-56">
            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-57">
              <UserIcon size={18} className="text-gray-400" data-id="element-58" />
            </div>
            <input id="userId" type="text" value={userId} onChange={e => setUserId(e.target.value)} className="w-full pl-10 pr-3 py-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#F58220] focus:border-transparent" placeholder="Enter your user ID" required data-id="element-59" />
          </div>
        </div>
        <div className="space-y-2" data-id="element-60">
          <div className="flex items-center justify-between" data-id="element-61">
            <label htmlFor="password" className="block text-sm font-medium text-gray-700" data-id="element-62">
              Password
            </label>
            <div className="relative group" data-id="element-63">
              <InfoIcon className="h-4 w-4 text-gray-500 cursor-help" data-id="element-64" />
              <div className="absolute right-0 bottom-full mb-2 w-64 bg-white border border-gray-200 rounded-md shadow-lg p-3 text-xs hidden group-hover:block z-10" data-id="element-65">
                <p className="font-medium text-gray-700 mb-1" data-id="element-66">
                  Password must contain:
                </p>
                <ul className="list-disc pl-4 text-gray-600 space-y-1" data-id="element-67">
                  <li data-id="element-68">Minimum 12 characters</li>
                  <li data-id="element-69">At least 1 uppercase letter</li>
                  <li data-id="element-70">At least 1 lowercase letter</li>
                  <li data-id="element-71">At least 1 number</li>
                  <li data-id="element-72">At least 1 special character</li>
                </ul>
              </div>
            </div>
          </div>
          <div className="relative" data-id="element-73">
            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-74">
              <LockIcon size={18} className="text-gray-400" data-id="element-75" />
            </div>
            <input id="password" type={showPassword ? 'text' : 'password'} value={password} onChange={e => setPassword(e.target.value)} className="w-full pl-10 pr-10 py-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#F58220] focus:border-transparent" placeholder="Enter your password" required data-id="element-76" />
            <button type="button" className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500" onClick={() => setShowPassword(!showPassword)} data-id="element-77">
              {showPassword ? <EyeOffIcon size={18} data-id="element-78" /> : <EyeIcon size={18} data-id="element-79" />}
            </button>
          </div>
        </div>
        <div data-id="element-80">
          <button type="submit" disabled={!isValidForm} className={`w-full py-3 px-4 rounded-md font-medium text-white transition-colors ${isValidForm ? 'bg-[#F58220] hover:bg-[#e07619] focus:outline-none focus:ring-2 focus:ring-[#F58220] focus:ring-opacity-50' : 'bg-gray-300 cursor-not-allowed'}`} data-id="element-81">
            Login
          </button>
        </div>
        <div className="text-center" data-id="element-82">
          <button type="button" onClick={() => setShowForgotPassword(true)} className="text-sm text-[#F58220] hover:text-[#e07619] font-medium" data-id="element-83">
            Forgot Password?
          </button>
        </div>
      </form>
    </div>;
}